module.exports = __webpack_public_path__ + "static/media/boat2-copyright.ceeb2a9a.jpeg";